export const initialise = () => {
    const shortlistItems = document.querySelectorAll<HTMLElement>('.inline-shortlist-widget');
    
    shortlistItems.forEach((widget) => {
        const countEl = widget.querySelector<HTMLElement>('.fav-count')
        if (!countEl) return;

        const updateAriaLabel = () => {
            const count = parseInt(countEl.textContent ?? '0', 10) || 0
            widget.setAttribute('aria-label', `${count} ${count === 1 ? 'job' : 'jobs'} in shortlist`)
        }
        updateAriaLabel()

        const observer = new MutationObserver(updateAriaLabel)
        observer.observe(countEl, { childList: true, subtree: true, characterData: true })
    })
}